define(function () {

    'use strict';

    var prefix = "fx.visualization.";

    return {

        remove: prefix + "remove",
        resize: prefix + "resize",
        clone: prefix + "clone",
        flip: prefix + "flip",
        metadata: prefix + "metadata",
        tab: prefix + "tab",
        query: prefix + "query",
        
        toolbar: prefix + "toolbar",

        model_done : "model.done",
        model_error : "model.error"

    };
});



//////////////////
// WEBPACK FOOTER
// ./src/config/events.js
// module id = 8
// module chunks = 0